import { render, staticRenderFns } from "./SubdomainsModal.vue?vue&type=template&id=da060a80&"
import script from "./SubdomainsModal.vue?vue&type=script&lang=js&"
export * from "./SubdomainsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports